// extracted by mini-css-extract-plugin
var _1 = "WelcomeScreen_WelcomeScreen__rkzPh";
var _2 = "WelcomeScreen_welcomeContent__zAfP3";
var _3 = "WelcomeScreen_welcomeContentContainer__RMZAq";
export { _1 as "WelcomeScreen", _2 as "welcomeContent", _3 as "welcomeContentContainer" }
